// CodiceQR.tsx — il link della sfida come codice QR (v019): chi è vicino lo inquadra con la fotocamera.
// Disegnato in SVG (nero su bianco, con il margine bianco che serve ai lettori), niente servizi esterni.
import { useMemo } from "react";
import qrcode from "qrcode-generator";

export function CodiceQR({ testo, dimensione = 240, etichetta }: { testo: string; dimensione?: number; etichetta: string }) {
  const { n, percorso } = useMemo(() => {
    const q = qrcode(0, "M");
    q.addData(testo);
    q.make();
    const n = q.getModuleCount();
    let d = "";
    for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (q.isDark(r, c)) d += `M${c + 4} ${r + 4}h1v1h-1z`;
    return { n, percorso: d };
  }, [testo]);
  const lato = n + 8;
  return (
    <svg className="ld-qr" role="img" aria-label={etichetta} width={dimensione} height={dimensione} viewBox={`0 0 ${lato} ${lato}`} shapeRendering="crispEdges">
      <rect width={lato} height={lato} fill="#FFFFFF" />
      <path d={percorso} fill="#0E0A24" />
    </svg>
  );
}
